import { render, staticRenderFns } from "./ChangeLogs.vue?vue&type=template&id=1e7c86cb&scoped=true&"
import script from "./ChangeLogs.vue?vue&type=script&lang=js&"
export * from "./ChangeLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7c86cb",
  null
  
)

export default component.exports